import React, { useState } from 'react'
import './navbar.css'
import four from '../../images/four.svg'

const Navbar = () => {

  const [expended, setExpended] = useState(false)

  const hamburgerHandler = () => {
    setExpended(!expended)
  }
  return (
    <section className='navbar' id='navbar'>

      <div className={`${expended ? 'expended-nav' : ''} small-nav`}>
                <a href="#about" className='link'>
                 <div className="navbar-item small-navbar-item" onClick= {hamburgerHandler}>About</div>
                </a>

                <a href="#services" className='link'>
                  <div className="navbar-item small-navbar-item" onClick= {hamburgerHandler}>Services</div>
                </a>
                
                <a href="#work" className='link'>
                  <div className="navbar-item small-navbar-item" onClick= {hamburgerHandler}>Work</div>
                </a>

                <a href="#contact" className='link'>
                  <div className="navbar-item small-navbar-item" onClick= {hamburgerHandler}>Contact</div>
                </a>
      </div>
      
      <div className="navbar-container">
        <div className="navbar-wrapper">
            <div className="navbar-left">NEGGAZ HICHEM</div>
            <img src={four} alt="four" id='four' className='bg'/>

            <div className="navbar-right">

                <a href="#about" className='link'>
                  <div className="navbar-item">About</div>
                </a>

                <a href="#services" className='link'>
                  <div className="navbar-item">Services</div>
                </a>
                
                <a href="#work" className='link'>
                  <div className="navbar-item">Work</div>
                </a>

                <a href="#contact" className='link'>
                  <div className="navbar-item">Contact</div>
                </a>

            </div>
            <div className='hamburger'
                 onClick= {hamburgerHandler}
            >
              <span className={`${expended ? 'hamburger-expended' : ''} hamburger-line`}></span>
              <span className={`${expended ? 'hamburger-expended' : ''} hamburger-line`}></span>
            </div>
        </div>
      </div>

      
    </section>
    
  )
}

export default Navbar
